import SocialBenchmarking from './SocialBenchmarking';

export default SocialBenchmarking;
